module.exports = __webpack_public_path__ + "img/A.76500410.png";